import { BLOG_SLUG, SITE_URL } from '../constants/global';
import compact from './helpers/compact';

// TODO : refactor this to avoid having external and internal link in all ctas
export const createLocalLink = ({
  linkUrl,
  siteUrl,
}: {
  linkUrl: string;
  siteUrl?: string;
}) => {
  if (linkUrl === '#' || !siteUrl) {
    return undefined;
  }
  const newUri = linkUrl?.replace(siteUrl, '');
  return newUri;
};

export const createBlogLink = (url: string | null) =>
  compact(
    ['categorie/', 'article/'].map((slug) => url?.replace(slug, BLOG_SLUG))
  )[0];

// TODO : refactor this to avoid having external and internal link in all ctas
export const isExternalLink = ({
  url,
  siteUrl,
}: {
  url: string | null | undefined;
  siteUrl?: string;
}) => {
  if (!siteUrl) return null;
  const urlWithoutHTTPS = url?.replace('https://', '').replace('http://', '');
  const wordpressUrlWithoutHTTPS = siteUrl
    .replace('https://', '')
    .replace('http://', '');
  return url?.includes('http') &&
    !urlWithoutHTTPS?.includes(wordpressUrlWithoutHTTPS)
    ? true
    : false;
};

export const getCorrectLink = (
  url?: string
): {
  href?: string;
  to?: string;
  isEmail?: boolean;
  shouldObfuscate?: boolean;
} | null => {
  if (!url) return null;
  if (url?.includes('mailto:')) {
    const email = url.replace('mailto:', '');
    return { isEmail: true, shouldObfuscate: true, to: email };
  }
  const siteUrl = SITE_URL;
  const isExternal = isExternalLink({
    siteUrl,
    url,
  });
  if (isExternal) return { href: url ?? undefined };
  const internalLink = createLocalLink({
    linkUrl: url,
    siteUrl,
  });
  return { to: internalLink };
};

export const getUrlWithoutDomain = ({
  domain,
  url,
}: {
  domain: string;
  url: string;
}) => {
  const domainWithTrailingSlash = addTrailingSlash(domain);
  return url?.replace(domainWithTrailingSlash, '');
};

export const addTrailingSlash = (path: string) => {
  const lastPathChar = path.charAt(path.length - 1);
  return lastPathChar === '/' ? path : path + '/';
};

export const removeDoubleSlash = (path: string) => {
  const indexOfHttpEnd = path.indexOf('://');
  if (indexOfHttpEnd === -1) {
    return path.replace(/\/\//g, '/');
  } else {
    const firstPartOfUrl = path.substring(0, indexOfHttpEnd + 3);
    const secondPartOfUrl = path.substring(indexOfHttpEnd + 3, path.length);
    return `${firstPartOfUrl}${secondPartOfUrl.replace(/\/\//g, '/')}`;
  }
};

export const addBlogToUrl = ({ uri, url }: { uri?: string; url?: string }) => {
  if (!uri || !url) return undefined;
  const urlWithoutUri = url.replace(`${uri}/`, '');
  return urlWithoutUri + 'blog/' + uri;
};
